import { Session } from '@ais-ui/auth';
import { ShipInfoByPropertiesProps, Target } from '../shipInfo';
import {
  ExtractedTargetInfo,
  extractTargetInfos,
  QueryPointResult,
} from '../extractTargetInfo';
import { trackOperation } from '@ais-ui/performance-tracking';

export const getTargetInfoAtPixel = async (
  session: Session,
  x: number,
  y: number,
  selectTarget: boolean,
  deselectOtherTargets: boolean
): Promise<ExtractedTargetInfo | null> => {
  const response: QueryPointResult = await session.request('queryPoint', {
    x: x,
    y: y,
    selectTarget: selectTarget,
    deselectOtherTargets: deselectOtherTargets,
  });

  const targetInfos = extractTargetInfos(response);
  if (targetInfos.extractedTargetInfo.length === 0) {
    return null;
  } else {
    return targetInfos;
  }
};

export const findTarget = async (
  session: Session,
  props: ShipInfoByPropertiesProps | null
): Promise<Target | null> => {
  if (!props) {
    return null;
  }
  const { type, mmsi, imo, name, callSign } = props;

  const parsedImo = parseInt(imo ? imo : '', 10);
  const imoInteger = isNaN(parsedImo) ? -1 : parsedImo;

  // It's important that we return a string otherwise search will not work for non-ship targets
  const stringCallSign = callSign ? callSign : '';
  const stringName = name ? name : '';

  // Force shows the ship even if it is filtered out
  const force = props?.filteredOut || false;

  const response = await session.request('findTarget', {
    type: type,
    mmsi: mmsi,
    imo: imoInteger,
    name: stringName,
    callSign: stringCallSign,
    force: force,
  });

  return response;
};

const _getShipInfo = async (session: Session): Promise<any> => {
  const response = await session.request('getTargetInfo', {});
  return response;
};

export const getShipInfo = (session: Session): Promise<any> => {
  return trackOperation(() => _getShipInfo(session), 'ship.get', 'data.fetch', {
    resourceType: 'shipInfo',
    transport: 'websocket',
    method: 'getTargetInfo',
  })();
};
